import React from 'react';

const TimesheetEntrySkeleton = ({ delay = 0, viewMode = 'list' }) => {
  
  // Card view skeleton
  if (viewMode === 'card') {
    return (
      <div 
        className="bg-white rounded-lg border border-border p-4 animate-pulse"
        style={{ animationDelay: `${delay}ms` }}
      >
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            {/* Company Name */}
            <div className="h-5 w-3/4 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2"></div>
            {/* Project Name */}
            <div className="h-4 w-1/2 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-3"></div>
          </div>
          {/* Status Badge */}
          <div className="h-6 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full"></div>
        </div>

        <div className="space-y-2 mb-4">
          {/* Time */}
          <div className="h-4 w-32 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          {/* Hours */}
          <div className="h-4 w-24 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-border">
          {/* Amount */}
          <div className="h-5 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
          {/* Action Button */}
          <div className="h-8 w-8 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  // List view skeleton (default)
  return (
    <div 
      className="bg-white rounded-lg border border-border p-4 animate-pulse mb-3"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-start gap-3">
            {/* Company Logo Skeleton */}
            <div className="h-10 w-10 rounded bg-gradient-to-r from-gray-200 to-gray-300 flex-shrink-0"></div>
            
            <div className="flex-1 min-w-0">
              {/* Company/Project Name */}
              <div className="h-5 bg-gradient-to-r from-gray-200 to-gray-300 rounded mb-2 w-3/4"></div>
              
              {/* Time and Duration */}
              <div className="space-y-1 mb-2">
                <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded w-2/3"></div>
                <div className="h-4 bg-gradient-to-r from-gray-200 to-gray-300 rounded w-1/3"></div>
              </div>

              {/* Description */}
              <div className="h-3 bg-gradient-to-r from-gray-200 to-gray-300 rounded w-1/2 mb-2"></div>
              
              {/* Meta Info */}
              <div className="flex gap-4 mt-2">
                <div className="h-3 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
                <div className="h-3 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
                <div className="h-3 w-24 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Right side - Status and Actions */}
        <div className="flex flex-col items-end gap-2 ml-4">
          {/* Status Badge */}
          <div className="h-6 w-20 bg-gradient-to-r from-gray-200 to-gray-300 rounded-full"></div>
          
          {/* Amount */}
          <div className="h-5 w-16 bg-gradient-to-r from-gray-200 to-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default TimesheetEntrySkeleton;
